var LayoutPerspective = require('./../layout/LayoutPerspective');
var appointmentLayoutTemplate = require('./appointmentLayoutTemplate.hbs');
var PortalPerspectiveLayoutBehavior = require('./../PortalPerspectiveLayoutBehavior');
var AsideBehavior = require('./../aside/AsideBehavior');

/**
 * Perspective to display the lists of appointments for a patient.
 *
 * @class AppointmentTabsPerspective
 * @constructor
 */
module.exports = LayoutPerspective.extend({
  template: appointmentLayoutTemplate,
  moduleNamespace: 'appointment',

  behaviors: {
    portalPerspectiveLayoutBehavior: {
      behavior: PortalPerspectiveLayoutBehavior
    },
    asideBehavior: {
      behavior: AsideBehavior,
      asideHeaderMessageKey: 'appointment.aside.header',
      asideContentMessageKey: 'appointment.aside'
    }
  },

  prepareFields: {
    patientVecnaId: '_patientVecnaId'
  },

  injectionSites: {
    'appointment-tabs': '_appointmentTabsView'
  },

  /**
   * @method initialize
   * @override
   * @param options {Object} the options of this perspective.
   *   @param options.appointmentTabsView {AppointmentTabsView} the shared tabs view to use for this perspective.
   */
  initialize: function(options) {
    LayoutPerspective.prototype.initialize.apply(this);
    this._appointmentTabsView = options.appointmentTabsView;
  }
});
